<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
      
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="员工姓名">
          <j-dict-select-tag type="list" v-decorator="['userId', validatorRules.username]" :trigger-change="true" dictCode="sys_user,realname,id" placeholder="请选择用户"/>
          <!--<a-input placeholder="请选择用户" v-decorator="['userId', validatorRules.username]" />-->
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="身份证号">
          <a-input placeholder="请输入身份证号" v-decorator="['cardNo', validatorRules.cardNo]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="政治面貌">
          <j-dict-select-tag type="list" placeholder="请输入政治面貌" v-decorator="['politicalStatus', {}]" :trigger-change="true" dictCode="political_status"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="签约状态">
          <j-dict-select-tag :disabled="addFlag == 0" type="list" placeholder="请输入签约状态" v-decorator="['signStatus', validatorRules.signStatus]" :trigger-change="true" dictCode="sign_status"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="学历">
          <j-dict-select-tag type="list" placeholder="请输入学历" v-decorator="['education', validatorRules.education]" :trigger-change="true" dictCode="education"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="毕业院校">
          <a-input placeholder="请输入第一毕业院校" v-decorator="['university', validatorRules.university]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="专业">
          <a-input placeholder="请输入专业" v-decorator="['specialty', validatorRules.specialty]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="毕业时间">
          <a-date-picker format='YYYY-MM-DD' v-decorator="[ 'graduationDate', validatorRules.graduationDate]" style="width: 100%"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="参加工作时间">
          <a-date-picker format='YYYY-MM-DD' v-decorator="[ 'startWorkingDate', validatorRules.startWorkingDate]" style="width: 100%"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="工龄">
          <a-input-number v-decorator="[ 'workingAge', {}]"  style="width: 100%"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="岗位类型">
          <j-dict-select-tag type="list" placeholder="请输入岗位类型" v-decorator="['positionType', validatorRules.positionType]" :trigger-change="true" dictCode="position_type"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="入职时间">
          <a-date-picker format='YYYY-MM-DD' v-decorator="[ 'entryTime', validatorRules.entryTime]" style="width: 100%"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="转正时间">
          <a-date-picker format='YYYY-MM-DD' v-decorator="[ 'regularTime', {}]" style="width: 100%"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="离职时间">
          <a-date-picker format='YYYY-MM-DD' v-decorator="[ 'quitTime', {}]" style="width: 100%"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="用工方式">
          <j-dict-select-tag type="list" placeholder="请输入用工方式" v-decorator="['employmentMode', {}]" :trigger-change="true" dictCode="employment_mode"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="标记">
          <j-dict-select-tag type="list" placeholder="请选择标记" v-decorator="['mark', validatorRules.mark]" :trigger-change="true" dictCode="mark"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="劳动合同截止日期">
          <a-date-picker format='YYYY-MM-DD' v-decorator="[ 'laborContractDeadline', {}]"  style="width: 100%" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="是否签订保密协议">
          <j-dict-select-tag type="list" placeholder="请输入是否签订保密协议" v-decorator="['signSecrecyAgreement', {}]" :trigger-change="true" dictCode="yn"/>
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="执业编号">
          <a-input placeholder="请输入执业编号" v-decorator="['practiceNo', {}]" />
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="培训经历">
          <a-textarea placeholder="请输入培训经历" :rows="4" v-decorator="['trainingExperience', {}]"/>
          <!--<a-input placeholder=""  />-->
        </a-form-item>
        <a-form-item
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="奖惩经历">
          <a-textarea placeholder="请输入奖惩经历" :rows="4" v-decorator="['rewardExperience', {}]" />
        </a-form-item>
		
      </a-form>
    </a-spin>
  </j-modal>
</template>

<script>
  import { httpAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import moment from "moment"
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: "HRUserProfileModal",
    components: {
      JDictSelectTag
    },
    data () {
      return {
        title:"操作",
        visible: false,
        disabled: false, //是否新增
        addFlag: 0,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },

        confirmLoading: false,
        form: this.$form.createForm(this),
        validatorRules:{
          username:{ rules: [{required: true, message: '请选择用户!'}] },
          cardNo:{rules: [{required: true, message: '请输入身份证号!'}] },
          signStatus:{rules: [{required: true, message: '请选择签约状态!'}] },
          education:{rules: [{required: true, message: '请选择学历!'}] },
          university:{rules: [{required: true, message: '请输入毕业学校!'}] },
          specialty:{rules: [{required: true, message: '请输入专业!'}] },
          graduationDate:{rules: [{required: true, message: '请输入毕业时间!'}] },
          startWorkingDate:{rules: [{required: true, message: '请选择参加工作时间!'}] },
          positionType:{rules: [{required: true, message: '请选择岗位类型!'}] },
          mark:{rules: [{required: true, message: '请选择是否为特殊标记!'}] },
          entryTime:{rules: [{required: true, message: '请选择入职时间!'}] }
        },
        url: {
          add: "/hr/hRUserProfile/add",
          edit: "/hr/hRUserProfile/edit",
        },
      }
    },
    created () {
    },
    methods: {
      add () {
        this.edit({});
        this.addFlag = 1;
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.addFlag = 0;
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'userId','cardNo','politicalStatus','signStatus','education','university','specialty','workingAge','positionType','employmentMode','signSecrecyAgreement','practiceNo','trainingExperience','rewardExperience','mark'))
		  //时间格式化
          this.form.setFieldsValue({graduationDate:this.model.graduationDate?moment(this.model.graduationDate):null})
          this.form.setFieldsValue({startWorkingDate:this.model.startWorkingDate?moment(this.model.startWorkingDate):null})
          this.form.setFieldsValue({entryTime:this.model.entryTime?moment(this.model.entryTime):null})
          this.form.setFieldsValue({regularTime:this.model.regularTime?moment(this.model.regularTime):null})
          this.form.setFieldsValue({quitTime:this.model.quitTime?moment(this.model.quitTime):null})
          this.form.setFieldsValue({laborContractDeadline:this.model.laborContractDeadline?moment(this.model.laborContractDeadline):null})
        });

      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            //时间格式化
            formData.graduationDate = formData.graduationDate?formData.graduationDate.format('YYYY-MM-DD HH:mm:ss'):null;
            formData.startWorkingDate = formData.startWorkingDate?formData.startWorkingDate.format('YYYY-MM-DD HH:mm:ss'):null;
            formData.entryTime = formData.entryTime?formData.entryTime.format('YYYY-MM-DD HH:mm:ss'):null;
            formData.regularTime = formData.regularTime?formData.regularTime.format('YYYY-MM-DD HH:mm:ss'):null;
            formData.quitTime = formData.quitTime?formData.quitTime.format('YYYY-MM-DD HH:mm:ss'):null;
            formData.laborContractDeadline = formData.laborContractDeadline?formData.laborContractDeadline.format('YYYY-MM-DD HH:mm:ss'):null;

            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
        })
      },
      handleCancel () {
        this.close()
      },
    }
  }
</script>

<style lang="less" scoped>

</style>